const AUTH_TOKEN_KEY = "auth_token";
const USERNAME_KEY = "username";

export function setAuthToken(token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function getAuthToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
}


export function setUsername(username) {
    localStorage.setItem(USERNAME_KEY, username);
}

export function getUsername() {
    return localStorage.getItem(USERNAME_KEY);
}

export function removeAuthToken() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function isLoggedIn() {
    return !!getAuthToken();
}
